import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common/common.service';
import { ContactUsService } from 'src/app/services/contact-us/contact-us.service';
import { ValidatorService } from 'src/app/services/validators/errors-validators.service';
import { ContactUs } from 'src/models/interfaces/contact-us/contact-us.interface';
import { HomeComponent } from '../../home/home.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';

@Component({
    selector: 'spe-fale-conosco',
    templateUrl: './fale-conosco.component.html',
    styleUrls: ['./fale-conosco.component.scss'],
    standalone: false
})
export class FaleConoscoComponent implements OnInit {
  validatorErrors = this.validatorService.validatorErrors;
  public message: string = '';
  public apiStatus: string | null = null;
  public listSubject: any[] = [
    { value: 'Sugestões para o site' },
    { value: 'Sugestões para entrega' },
    { value: 'Elogios' },
    { value: 'Dúvidas sobre o site' },
    { value: 'Dúvidas sobre o vale-transporte' },
    { value: 'Dúvidas sobre outros benefícios' },
    { value: 'Outras informações' }
  ];
  public site = localStorage.getItem('site');
  public sigla = localStorage.getItem('sigla');
  public errorsToShow: any[] = [];
  private _snackBar = inject(MatSnackBar);

  public mainFormGroup = new FormGroup({
    tipoFormControl: new FormControl('', [Validators.required]),
    assuntoFormControl: new FormControl('', [Validators.required]),
    emailFormControl: new FormControl('', [Validators.required, Validators.email]),
    mensagemFormControl: new FormControl('', [Validators.required]),
    nomeFormControl: new FormControl('', [Validators.required]),
    telefoneFormControl: new FormControl('', [Validators.required]),
    ramalFormControl: new FormControl('')
  });

  constructor(
    public readonly routerService: Router,
    public readonly validatorService: ValidatorService,
    public readonly commonService: CommonService,
    public readonly contactUsService: ContactUsService,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit(): void {
    this.setHomeVariables();
  }

  public openSnackBar(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 10000,
      data: { message: message }
    });
  }

  setHomeVariables() {
    this.homeComponent.setNewVariables(
      'Fale conosco',
      `A ${this.site} quer simplificar o seu trabalho e a sua vida. Para entrar em contato conosco, escolha abaixo a melhor opção para você.`
    );
    this.homeComponent.idleMenuContent = [];
    this.homeComponent.iconPath = 'assets/images/64_icon_user_message.png';
  }

  public keypress = (event: KeyboardEvent) => {
    const regex = /^[0-9]$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  };

  public returnButton = () => {
    this.routerService.navigate([`home`]);
  };

  public submitButton = () => {
    const newContactUs: ContactUs = <ContactUs>{
      assunto: this.mainFormGroup.controls.assuntoFormControl.value,
      email: this.mainFormGroup.controls.emailFormControl.value?.toLowerCase(),
      mensagem: this.mainFormGroup.controls.mensagemFormControl.value,
      nome: this.mainFormGroup.controls.nomeFormControl.value,
      telefone: `${this.mainFormGroup.controls.telefoneFormControl.value?.slice(
        0,
        2
      )}-${this.mainFormGroup.controls.telefoneFormControl.value?.slice(2)}
      -Ramal:${this.mainFormGroup.controls.ramalFormControl.value}`
    };
    this.mainFormGroup.markAllAsTouched();
    newContactUs.motivo = this.mainFormGroup.value.tipoFormControl!;

    if (this.mainFormGroup.valid) {
      this.contactUsService.createContactUs(newContactUs).subscribe({
        next: () => {
          this.errorsToShow = [];
          this.openSnackBar(`Sua mensagem foi enviada com sucesso. A ${this.site} agradece o seu contato.`);
          this.mainFormGroup.reset();
        },
        error: (error) => {
          this.errorsToShow = [];
          let errorMensagem: string = error.error.mensagem;
          if (errorMensagem.includes('Requisição possui campos inválidos')) {
            error.error.erros.forEach((value: any) => {
              this.errorsToShow.push(value.mensagem);
            });
            this.openSnackBar(`Requisição possui campos inválidos: ${this.errorsToShow.join(' ')} `);
          } else {
            this.openSnackBar(errorMensagem);
          }
        }
      });
    }
  };
}
